import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { I18nModule } from '../i18n';
import { AuthRouting } from './auth.routing';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { AlertMessageComponent, ButtonComponent, IconComponent } from '../shared/components/ui';
import { FormErrorComponent } from '../shared/components';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, I18nModule, AuthRouting, IconComponent, FormsModule, ButtonComponent, FormErrorComponent, AlertMessageComponent],
  declarations: [LoginComponent, LogoutComponent, ForgotPasswordComponent],
})
export class AuthModule {}
